"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n\n  @media ", " {\n    display: ", ";\n  }\n\n  @media ", " {\n    display: ", ";\n  }\n\n  @media ", " {\n    display: ", ";\n  }\n"], ["\n  display: ", ";\n\n  @media ", " {\n    display: ", ";\n  }\n\n  @media ", " {\n    display: ", ";\n  }\n\n  @media ", " {\n    display: ", ";\n  }\n"])), function (_a) {
    var $at = _a.$at;
    return ($at.includes('small') ? 'block' : 'none');
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $at = _a.$at;
    return ($at.includes('medium') ? 'block' : 'none');
}, theme_1.theme.breakpoints.large, function (_a) {
    var $at = _a.$at;
    return ($at.includes('large') ? 'block' : 'none');
}, theme_1.theme.breakpoints.xlarge, function (_a) {
    var $at = _a.$at;
    return ($at.includes('xlarge') ? 'block' : 'none');
});
var Show = function (_a) {
    var at = _a.at, props = __rest(_a, ["at"]);
    return react_1.default.createElement(Wrapper, __assign({}, props, { "$at": at }));
};
exports.default = Show;
var templateObject_1;
